module.exports = __webpack_public_path__ + "static/media/bellActive.abea4f24.svg";